var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersona2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "595px",
    height: "842px",
    viewBox: "0 0 595 842",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "persona2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.118890428 23.6155793 0.118890428 23.6155793 26.4913869 0 26.4913869"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.257815908 0.0293688574 23.8827478 0.0293688574 23.8827478 26.4024172 0.257815908 26.4024172"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 306.403485 112.21453 306.403485 112.21453 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "persona2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 595,
    height: 842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,39 L437,39 C456.882251,39 473,55.117749 473,75 L473,75 C473,94.882251 456.882251,111 437,111 L0,111 L0,39 Z",
    id: "Rectangle",
    fill: "#ACE3E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,131 L501,131 C520.882251,131 537,147.117749 537,167 L537,167 C537,186.882251 520.882251,203 501,203 L0,203 L0,131 Z",
    id: "Rectangle-Copy",
    fill: "#ACE3E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-53",
    transform: "translate(47.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 57.000559)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8289714,0.668591689 C19.8289714,0.668591689 9.56987803,-2.54726719 -0.000959242021,6.57752254 C-0.000959242021,6.57752254 0.557799235,15.5536298 5.10940263,22.3522576 L12.742571,19.2611002 L7.05186772,24.942211 L8.84085409,26.4913869 C8.84085409,26.4913869 23.517257,21.4865417 23.6155793,8.86531476 C23.6155793,8.86531476 19.2342414,6.41924761 19.8289714,0.668591689",
    id: "Fill-1",
    fill: "#000100",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.109819,54.7628872 C23.109819,54.7628872 19.7452776,56.1753711 19.3184149,58.3480542 C18.8891541,60.5135431 19.5510311,68.2570243 24.3136677,68.592759 C24.3136677,68.592759 25.8292701,69.1778967 26.9731662,66.8277537 C26.9731662,66.8277537 22.5126908,59.1466232 23.109819,54.7628872",
    id: "Fill-4",
    fill: "#2D4D2E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(88.331782, 57.000559)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0516181,0.579621991 C4.64395005,6.33027791 0.257815908,8.77394696 0.257815908,8.77394696 C0.356138215,21.397572 15.0421336,26.4024172 15.0421336,26.4024172 L16.8287218,24.8556394 L11.1356204,19.1745286 L18.7663907,22.265686 C23.315596,15.4694563 23.8839469,6.49095095 23.8839469,6.49095095 C14.3011191,-2.63863499 4.0516181,0.579621991 4.0516181,0.579621991",
    id: "Fill-6",
    fill: "#373736",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.0929601,53.4501645 C89.6828939,57.8315024 85.2296128,65.515031 85.2296128,65.515031 C86.3807033,67.865174 87.8891113,67.2800363 87.8891113,67.2800363 C92.6469518,66.9443016 93.3088288,59.1960242 92.8819661,57.0305353 C92.4551034,54.8602502 89.0929601,53.4501645 89.0929601,53.4501645",
    id: "Fill-9",
    fill: "#3B673D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3020881,53.0930866 C19.9783734,61.4001225 25.4532472,60.6926815 25.4532472,60.6926815 L21.6714356,43.7021072 C21.6714356,43.7021072 14.6329972,44.7884488 17.3020881,53.0930866",
    id: "Fill-11",
    fill: "#C8A985"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6620304,43.7033063 L85.8826168,60.6938806 C85.8826168,60.6938806 91.3574907,61.3989235 94.0313778,53.0942857 C96.7052649,44.7872498 89.6620304,43.7033063 89.6620304,43.7033063",
    id: "Fill-13",
    fill: "#C8A985"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#C8A985",
    mask: "url(#mask-6)",
    points: "49.3170304 94.6795856 62.1732716 94.6795856 62.1732716 81.8401312 49.3170304 81.8401312"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6039026,4.25879476 C36.1696593,4.25879476 20.4284977,19.9783734 20.4284977,39.3670527 C20.4284977,58.7557321 24.1983188,88.269211 55.6039026,88.269211 C90.2613169,88.269211 90.7793075,58.7557321 90.7793075,39.3670527 C90.7793075,19.9783734 75.0309517,4.25879476 55.6039026,4.25879476",
    id: "Fill-17",
    fill: "#D1BA9C",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4330541,39.3660935 C20.4330541,58.7547729 24.198079,88.2706499 55.608459,88.2706499 L55.608459,4.25783552 C36.1766138,4.25783552 20.4330541,19.9798123 20.4330541,39.3660935",
    id: "Fill-18",
    fill: "#C8A985",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2083419,17.9306315 C11.2082634,29.5518486 19.4361618,51.5424719 19.4361618,51.5424719 C36.2516745,47.9117409 55.6091785,15.24955 55.6091785,15.24955 L55.6091785,4.25903457 C35.4099396,3.60914811 19.2083419,17.9306315 19.2083419,17.9306315",
    id: "Fill-19",
    fill: "#000100",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4142125,4.25879476 L55.4142125,15.2493102 C55.4142125,15.2493102 75.1410247,48.0865627 91.9517411,51.7148957 C91.9517411,51.7148957 99.9805968,29.5516088 91.9781203,17.9303917 C91.9781203,17.9303917 75.6134514,3.60890829 55.4142125,4.25879476",
    id: "Fill-20",
    fill: "#373736",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1544237,15.4529093 C23.2047839,15.5656203 23.092073,15.6327672 23.092073,15.6327672 C37.4783052,6.58471686 55.4137329,10.4816376 55.4137329,10.4816376 L55.4137329,1.54150193 C52.7566325,-4.62642427 20.4973233,9.28498314 23.1544237,15.4529093",
    id: "Fill-21",
    fill: "#000100",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3720059,0.876987018 L55.3720059,9.81952076 C55.3720059,9.81952076 73.3074336,5.92020194 87.6960639,14.9658542 C87.6960639,14.9658542 87.6792771,14.9035035 87.631315,14.7859963 C86.9814286,13.042574 81.0389243,-0.600245695 55.3720059,0.876987018",
    id: "Fill-22",
    fill: "#373736",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#E6CEB3",
    mask: "url(#mask-6)",
    points: "61.4706268 296.612022 76.3005085 296.612022 76.3005085 212.52007 61.4706268 212.52007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4797298,298.314676 C60.4797298,301.849483 60.4797298,304.715219 66.875476,304.715219 L87.6958241,304.715219 C91.2234366,304.715219 94.086774,302.719995 94.086774,299.192383 C94.1107551,297.379415 92.8853234,294.573632 87.7677672,293.034049 L66.3454948,288.511223 C62.8178822,288.511223 60.4797298,294.782267 60.4797298,298.314676",
    id: "Fill-24",
    fill: "#E6CEB3",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#DEBE9A",
    mask: "url(#mask-6)",
    points: "35.1610163 296.612022 49.9884998 296.612022 49.9884998 212.52007 35.1610163 212.52007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9832338,298.314676 C50.9832338,301.849483 50.9832338,304.715219 44.5850895,304.715219 L23.7671396,304.715219 C20.2347308,304.715219 17.3713934,302.719995 17.3713934,299.192383 C17.3546066,297.379415 18.5776402,294.573632 23.6951964,293.034049 L45.1126726,288.511223 C48.6474795,288.511223 50.9832338,294.782267 50.9832338,298.314676",
    id: "Fill-26",
    fill: "#DEBE9A",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4752509,114.488413 L56.0391587,114.488413 L56.0391587,94.5889372 L46.7752789,94.5889372 C46.7752789,94.5889372 19.4752509,98.1525213 19.4752509,114.488413",
    id: "Fill-27",
    fill: "#E6CEB3",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5290862,117.21314 L24.4666668,103.78615 C24.4666668,103.78615 4.64153233,120.673606 6.59598795,186.14667 L15.5625027,186.14667 C15.5625027,186.14667 16.5337353,132.836794 31.5290862,117.21314",
    id: "Fill-28",
    fill: "#DEBE9A",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8735468,193.153933 C16.8735468,196.56164 14.1708824,199.324257 10.8351183,199.324257 C7.49455791,199.324257 4.78709731,196.56164 4.78709731,193.153933 L4.78709731,187.863713 C4.78709731,184.460802 7.49455791,181.695787 10.8351183,181.695787 C14.1708824,181.695787 16.8735468,184.460802 16.8735468,187.863713 L16.8735468,193.153933 Z",
    id: "Fill-29",
    fill: "#DEBE9A",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0913339,190.224168 C21.434263,191.173817 20.9354571,192.216993 19.9834094,192.555126 C19.0361579,192.893259 17.9929822,192.394453 17.6524513,191.444803 L16.6380529,188.732546 C16.2951238,187.782897 16.7915316,186.739721 17.7411812,186.403986 C18.6908308,186.063455 19.7388027,186.559863 20.0721393,187.509513 L21.0913339,190.224168 Z",
    id: "Fill-30",
    fill: "#DEBE9A",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9718985,187.286249 C19.9718985,187.286249 17.3387792,181.585953 11.1444738,181.715451 L11.1444738,188.641179 L16.6936889,188.641179 L19.9718985,187.286249 Z",
    id: "Fill-31",
    fill: "#DEBE9A",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7186542,95.1349858 C43.7186542,95.1349858 30.2101284,98.1781811 24.4666668,103.787349 C24.4666668,103.787349 31.4643374,108.060772 28.9295403,155.157157 L28.8360142,155.157157 L16.8742662,222.11225 L56.0401179,222.11225 L56.0401179,155.157157 L56.0401179,114.487694 L56.0401179,91.511449 L43.7186542,95.1349858 Z",
    id: "Fill-32",
    fill: "#373738",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7186542,95.1349858 C44.7402469,100.945594 53.7643162,103.787349 53.7643162,103.787349 L55.8722506,91.511449 L44.718664,90.2884154 L43.7186542,95.1349858 Z",
    id: "Fill-33",
    fill: "#DDDBDB",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0179288,114.488413 L55.4564192,114.488413 L55.4564192,94.5889372 L64.720299,94.5889372 C64.720299,94.5889372 92.0179288,98.1525213 92.0179288,114.488413",
    id: "Fill-34",
    fill: "#E6CEB3",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9619353,117.21314 L87.0267528,103.78615 C87.0267528,103.78615 106.86148,120.673606 104.902228,186.14667 L95.9309168,186.14667 C95.9309168,186.14667 94.9692767,132.836794 79.9619353,117.21314",
    id: "Fill-35",
    fill: "#E6CEB3",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6174747,193.153933 C94.6174747,196.56164 97.3225372,199.324257 100.658301,199.324257 C103.996464,199.324257 106.706322,196.56164 106.706322,193.153933 L106.706322,187.863713 C106.706322,184.460802 103.996464,181.695787 100.658301,181.695787 C97.3225372,181.695787 94.6174747,184.460802 94.6174747,187.863713 L94.6174747,193.153933 Z",
    id: "Fill-36",
    fill: "#E6CEB3",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3975292,190.224168 C90.0641926,191.173817 90.5606004,192.216993 91.5054538,192.555126 C92.4575015,192.893259 93.5006772,192.394453 93.8436062,191.444803 L94.8580046,188.732546 C95.1961374,187.782897 94.7021278,186.739721 93.7524782,186.403986 C92.8028286,186.063455 91.7572548,186.559863 91.419122,187.509513 L90.3975292,190.224168 Z",
    id: "Fill-37",
    fill: "#E6CEB3",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5215211,187.286249 C91.5215211,187.286249 94.1546404,181.585953 100.34415,181.715451 L100.34415,188.641179 L94.7997307,188.641179 L91.5215211,187.286249 Z",
    id: "Fill-38",
    fill: "#E6CEB3",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7769237,95.1349858 C67.7769237,95.1349858 81.2854495,98.1781811 87.0265129,103.787349 C87.0265129,103.787349 80.0312405,108.060772 82.5636394,155.157157 L82.6547674,155.157157 L94.6165154,222.11225 L55.4554599,222.11225 L55.4554599,155.157157 L55.4554599,114.487694 L55.4554599,91.511449 L67.7769237,95.1349858 Z",
    id: "Fill-39",
    fill: "#58585A",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7769237,95.1349858 C66.7505347,100.945594 57.7336597,103.787349 57.7336597,103.787349 L55.6209292,91.511449 L66.7745158,90.2884154 L67.7769237,95.1349858 Z",
    id: "Fill-40",
    fill: "#DDDBDB",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1755172,293.575781 C22.1755172,293.575781 26.5376703,295.280833 26.8710069,303.021917 L34.1756349,303.021917 C34.1756349,303.021917 33.8662794,295.542227 28.8230644,291.949866 C28.8230644,291.949866 24.0724183,292.582965 22.1755172,293.575781",
    id: "Fill-41",
    fill: "#464547",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3065518,298.889502 C32.3065518,298.889502 47.1891918,298.081341 49.9877804,293.488969 C49.9877804,293.488969 50.8870698,294.822316 50.8343115,296.611302 C50.8343115,296.611302 47.3330781,300.505825 32.3065518,301.179692 L32.3065518,298.889502 Z",
    id: "Fill-42",
    fill: "#464547",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3345562,304.987883 C51.3345562,305.769665 50.7062527,306.402765 49.9220723,306.402765 L18.434953,306.402765 C17.6531707,306.402765 17.020071,305.769665 17.020071,304.987883 L17.020071,304.433921 C17.020071,303.652139 17.6531707,303.021437 18.434953,303.021437 L49.9220723,303.021437 C50.7062527,303.021437 51.3345562,303.652139 51.3345562,304.433921 L51.3345562,304.987883 Z",
    id: "Fill-43",
    fill: "#2B2A2A",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2896047,293.575781 C89.2896047,293.575781 84.9250535,295.280833 84.5869207,303.021917 L77.2870889,303.021917 C77.2870889,303.021917 77.5964444,295.542227 82.6444556,291.949866 C82.6444556,291.949866 87.3855093,292.582965 89.2896047,293.575781",
    id: "Fill-44",
    fill: "#464547",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1564118,298.889502 C79.1564118,298.889502 64.2713737,298.081341 61.470387,293.488969 C61.470387,293.488969 60.5758938,294.822316 60.6286521,296.611302 C60.6286521,296.611302 64.1274874,300.505825 79.1564118,301.179692 L79.1564118,298.889502 Z",
    id: "Fill-45",
    fill: "#464547",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1284074,304.987883 C60.1284074,305.769665 60.7591091,306.402765 61.5384932,306.402765 L93.0280107,306.402765 C93.8049967,306.402765 94.4452907,305.769665 94.4452907,304.987883 L94.4452907,304.433921 C94.4452907,303.652139 93.8049967,303.021437 93.0280107,303.021437 L61.5384932,303.021437 C60.7591091,303.021437 60.1284074,303.652139 60.1284074,304.433921 L60.1284074,304.987883 Z",
    id: "Fill-46",
    fill: "#2B2A2A",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3512395,179.615431 C16.4135902,180.1598 16.0586707,180.65381 15.5574667,180.708966 L6.96265821,181.687393 C6.46385236,181.747346 6.0082124,181.354057 5.94586167,180.804891 C5.88111283,180.255725 6.23843049,179.766511 6.74203255,179.713753 L15.334443,178.73053 C15.838045,178.672975 16.2888888,179.068663 16.3512395,179.615431",
    id: "Fill-47",
    fill: "#464547",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-48",
    fill: "#AB966F",
    mask: "url(#mask-6)",
    points: "16.3605921 178.169373 16.3605921 178.169373 5.94082565 178.169373 5.94082565 174.003865 16.3605921 174.003865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0159755,92.4148152 C66.3565261,92.6138579 69.3421669,93.1054694 72.5604238,94.0215456 C74.641979,94.5827022 77.6180274,95.5755177 80.7571469,97.2134234 C82.2008062,97.9520398 83.6276787,98.7913765 85.0065891,99.7410261 C86.0953288,100.494031 87.0281916,101.314183 87.8483436,102.16551 C90.4167141,104.563615 92.6661366,107.578033 94.1002034,111.359845 L96.555863,116.525363 L84.3902761,122.446285 L84.4838022,127.506286 L87.1888647,175.382056 L55.7473093,175.382056 L55.7473093,112.462973 L55.7473093,111.438983 L55.7473093,100.585159 C61.7257852,100.585159 64.0159755,92.4148152 64.0159755,92.4148152",
    id: "Fill-49",
    fill: "#84A4A3",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0606632,92.4148152 C45.7201126,92.6138579 42.7344719,93.1054694 39.518613,94.0215456 C37.4370578,94.5827022 34.4586113,95.5755177 31.3218899,97.2134234 C29.8758326,97.9520398 28.4489601,98.7913765 27.077244,99.7410261 C25.9789119,100.494031 25.0484471,101.314183 24.2306933,102.16551 C21.6599247,104.563615 19.4129002,107.578033 17.9740372,111.359845 L15.5207757,116.525363 L27.6887608,122.446285 L27.5952347,127.506286 L24.8901722,175.382056 L56.3317275,175.382056 L56.3317275,112.462973 L56.3317275,111.438983 L56.3317275,100.585159 C50.3508535,100.585159 48.0606632,92.4148152 48.0606632,92.4148152",
    id: "Fill-50",
    fill: "#7E9091",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7702723,92.3304019 L46.9812761,92.4718901 C46.9812761,101.855675 56.3314877,101.551116 56.3314877,101.551116 L56.3314877,98.8724325 C50.6192015,98.8724325 49.7702723,92.3304019 49.7702723,92.3304019",
    id: "Fill-51",
    fill: "#373736",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7584092,92.3304019 L65.5474054,92.4718901 C65.5474054,101.855675 56.20199,101.551116 56.20199,101.551116 L56.20199,98.8724325 C61.9094801,98.8724325 62.7584092,92.3304019 62.7584092,92.3304019",
    id: "Fill-52",
    fill: "#373736",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Meimei-Han",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 36,
    fontWeight: "bold",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 219,
    y: 90
  }, "Meimei Han")), /*#__PURE__*/React.createElement("text", {
    id: "Reckoning-Workaholic",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 26,
    fontWeight: "bold",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 219,
    y: 177
  }, "Reckoning Workaholic")), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(219.000000, 233.000000)",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("text", {
    id: "INFO",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 22,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24
  }, "INFO")), /*#__PURE__*/React.createElement("text", {
    id: "Age:-24",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 64
  }, "Age: 24")), /*#__PURE__*/React.createElement("text", {
    id: "City:-Atlanta",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 148,
    y: 64
  }, "City: Atlanta")), /*#__PURE__*/React.createElement("text", {
    id: "Major:-Mechanical-En",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 93
  }, "Major: Mechanical Engineering"))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(47.000000, 523.000000)",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("text", {
    id: "User-Needs",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 22,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24
  }, "User Needs")), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    transform: "translate(0.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Wants-a-quick-and-di",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12,
    y: 19
  }, "Wants a quick and dirty food solution")), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 13.5,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-4",
    transform: "translate(0.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Save-money-on-dining",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12,
    y: 19
  }, "Save money on dining")), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 13.5,
    r: 3.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(47.000000, 675.000000)",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("text", {
    id: "User-Frustrations",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 22,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24
  }, "User Frustrations")), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    transform: "translate(0.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Has-no-time-for-cook",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12,
    y: 19
  }, "Has no time for cooking/preparing food")), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 13.5,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-4",
    transform: "translate(0.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Delivery-costs-are-h",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12,
    y: 19
  }, "Delivery costs are high")), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 13.5,
    r: 3.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(47.000000, 371.000000)",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("text", {
    id: "User-Features",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 22,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24
  }, "User Features")), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Working-day-and-nigh",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12,
    y: 19
  }, "Working day and night for his dues and finals")), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 13.5,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(0.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Relies-on-a-student",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12,
    y: 19
  }, "Relies on a student loan for education")), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 13.5,
    r: 3.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersona2);
export default __webpack_public_path__ + "static/media/persona2.2fbcb4f676a1d4b5b7a71e5e536a9c2f.svg";
export { ForwardRef as ReactComponent };